import React, { useEffect, useRef, useState } from 'react';
import M_PER_BASIC from './M_PER_BASIC';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Global from '../../../../Services/Common/Global';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSelector } from 'react-redux';
import Commons from '../../../../Services/Common/Common';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../Hooks/back/useBackStack';

const NOW = dayjs().format('YYYY-MM-DD HH:mm:ss');

export default function M_PER_BASICF() {
  const location = useLocation();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.searchInfo);
  const searchClick = useSelector((state) => state.permit.searchRequestId);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const searchRef = useRef({
    custCd: '',
    depCd: '',
    workDate: dayjs().format('YYYY-MM-DD'),
    searchText: '',
  });
  const [rowData1, setRowData1] = useState([]);
  const [gjInputs, setGjInputs] = useState({
    gjCd: '',
    gjList: [],
  });
  const [state, setState] = useState({
    bottom: false,
    type: '',
  });
  const [extendData, setExtendData] = useState({});

  const backTo = location.state?.from || '/Home';

  // 스택형 뒤로가기로 변경: 작업허가서 목록에서는 이전 진입 화면으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate(backTo, { replace: true }),
  });

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (searchClick) {
      SearchLogic1();
    }
  }, [searchClick]);

  useEffect(() => {
    searchRef.current = {
      custCd: searchInfo.custCd || userInfo?.custCd || '',
      depCd: searchInfo.depCd || '',
      workDate: searchRef.current.workDate || dayjs().format('YYYY-MM-DD'),
      searchText: searchInfo.searchText || '',
    };
  }, [searchInfo.custCd, searchInfo.depCd, searchInfo.searchText, userInfo?.custCd]);

  const Init = async () => {
    dispatch(NavBarInfoActions.setType('permit'));
    dispatch(CommonActions.resetActiveStep());

    await SearchDep();
    await SearchLogic1();
  };
  // 드로워 상태값 관리
  const ToggleDrawer = (anchor, open, gubun) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open, gubun: gubun });
  };

  // 공정 조회
  const SearchDep = async () => {
    setLoading(true);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_M20201_R3',
            _USER_ID: userInfo.userid,
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd),
          },
        ]
      ).then((result) => {
        let data = result.data;
        let changeData = [];
        if (data.length === 0) {
          setGjInputs({
            ...gjInputs,
            gjCd: '',
            gjList: [],
          });
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          data.forEach((_item) => {
            changeData.push({
              value: _item.GJ_CD,
              name: _item.GJ_NM,
            });
          });
          setGjInputs({
            ...gjInputs,
            gjList: changeData,
            gjCd: changeData[0].value,
          });
        }
      });
    } catch (e) {
      console.log(e);

      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 작업허가서 리스트 조회
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_R1',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', //로그인한 user 사업장코드
            _DEP_CD: Commons.EncryptAES(searchRef.current.depCd) || '',
            _WORK_DATE: Commons.EncryptAES(searchRef.current.workDate) || '',
            _USER_ID: userInfo.userid || '',
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '',
            _SEARCH_TEXT:
              Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          setRowData1([]);
          dispatch(PermitActions.setPermitAlarm(''));
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          const updatedData = Commons.InsertNumber(data);
          setRowData1(updatedData);

          if (updatedData.some((item) => item.GUBUN === '요청')) {
            dispatch(PermitActions.setPermitAlarm('요청'));
          } else if (updatedData.some((item) => item.GUBUN === '반려')) {
            dispatch(PermitActions.setPermitAlarm('반려'));
          } else {
            dispatch(PermitActions.setPermitAlarm(''));
          }
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 연장신청할 때 필요
  const SaveLogic1 = async (data) => {
    try {
      setLoading(true);
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_U1',
            _PM_CD: Commons.EncryptAES(data.PM_CD),
            _CUST_CD: Commons.EncryptAES(userInfo.custCd),
            _DEP_CD: Commons.EncryptAES(userInfo.depCd),
            _USER_ID: userInfo.userid,
            _CONSTRUCTION_NM: Commons.EncryptAES(data.CONSTRUCTION_NM),
            _SITE_MANAGER: Commons.EncryptAES(data.SITE_MANAGER),
            _SITE_PHONE: Commons.EncryptAES(data.SITE_PHONE),
            _WORK_START_DATE: Commons.EncryptAES(data.WORK_START_DATE || NOW),
            _WORK_END_DATE: Commons.EncryptAES(data.WORK_END_DATE || NOW),
            _WORK_DETAIL: Commons.EncryptAES(data.WORK_DETAIL),
            _WORK_PLACE: Commons.EncryptAES(data.WORK_PLACE),
            _WORK_MEMBER_NO: Commons.EncryptAES(
              String(data.WORK_MEMBER_NO ?? '')
            ),
            _DEP_HEAD_ID: Commons.EncryptAES(data.DEP_HEAD_ID || ''),
          },
        ]
      );
      dispatch(
        showSnackbar({ message: '연장 신청 완료되었습니다.', type: 'success' })
      );

      if (result.data[0]?.type === 'Error') {
        console.error(result.data[0]?.message);
        return;
      }
    } catch (error) {
      console.error(error);
      dispatch(showSnackbar({ message: '다시 시도해주세요.', type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  const handleExtendConfirm = async (time24) => {
    const newEnd = dayjs(extendData.WORK_END_DATE)
      .hour(Number(time24.split(':')[0]))
      .minute(Number(time24.split(':')[1]))
      .second(0)
      .format('YYYY-MM-DD HH:mm:ss');

    const updated = {
      ...extendData,
      WORK_END_DATE: newEnd,
    };

    setExtendData(updated);

    await SaveLogic1(updated);
    await SearchLogic1(userInfo);
  };

  const refreshClick = async () => {
    await SearchLogic1(userInfo);
  };

  return (
    <div>
      <M_PER_BASIC
        state={state}
        setState={setState}
        userInfo={userInfo}
        rowData1={rowData1}
        searchRef={searchRef}
        setExtendData={setExtendData}
        extendData={extendData}
        // 함수
        ToggleDrawer={ToggleDrawer}
        SearchLogic1={SearchLogic1}
        SaveLogic1={SaveLogic1}
        handleExtendConfirm={handleExtendConfirm}
        refreshClick={refreshClick}
      />
    </div>
  );
}
